import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { NavBar } from './components/NavBar';
import { Apresentacao } from './components/Apresentacao';
import { Sobre } from './components/Sobre';
import { Projetos } from './components/Projetos';
import { Contato } from './components/Contato';

function App() {
  return (
    <Router>
      <NavBar />
      <div id="apresentacao">
        <Apresentacao />
      </div>
      <div id="sobre">
        <Sobre />
      </div>
      <div id="projetos">
        <Projetos />
      </div>
      <div id="contato">
        <Contato />
      </div>

      <Routes>
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/projetos" element={<Projetos />} />
      </Routes>
    </Router>
  );
}

export default App;
